import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IPrice } from '@shared/jp/data/products';
import { ISpecs } from 'src/types';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultComponent {
  @Input() id!: string;

  @Input() title!: string;

  @Input() subtitle!: string;

  @Input() specs!: ISpecs;

  @Input() price!: IPrice;

  @Input() photo!: string;

  @Input() discount: string | undefined;

  @Output() close = new EventEmitter<void>();

  get specsKeys(): string[] {
    return Object.keys(this.specs);
  }

  // constructor() {}

  public onClose() {
    this.close.emit();
  }
}
